import { apiClient } from "@/lib/api-client";

export type UnsurMembimbingSeminarProposalData = Record<string, any>;

export type UnsurMembimbingSeminarProposalResponse = {
  datas: UnsurMembimbingSeminarProposalData;
  message: string;
};

export const fetchUnsurMembimbingSeminarProposal = async ({
  niu,
  year,
  semester,
  periodeID,
}: {
  niu: string;
  year: number;
  semester: number;
  periodeID?: number | null;
}): Promise<UnsurMembimbingSeminarProposalData> => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;

  const params = new URLSearchParams({
    year: year.toString(),
    semester: semester.toString(),
    ...(periodeID && { periodeID: periodeID.toString() }),
  });

  const resData = await apiClient<UnsurMembimbingSeminarProposalResponse>(
    `${baseUrl}/api/v1/unsur-membimbing-seminar-proposal/${niu}?${params.toString()}`,
    {
      headers: {
        Accept: "application/json",
      },
    },
  );

  return resData.datas;
};
